import { render, staticRenderFns } from "./bxDcOrderList.vue?vue&type=template&id=4746ad84&scoped=true&"
import script from "./bxDcOrderList.vue?vue&type=script&lang=js&"
export * from "./bxDcOrderList.vue?vue&type=script&lang=js&"
import style0 from "./bxDcOrderList.vue?vue&type=style&index=0&id=4746ad84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746ad84",
  null
  
)

export default component.exports